import { render, staticRenderFns } from "./AllDns.vue?vue&type=template&id=3860d2c1&"
import script from "./AllDns.vue?vue&type=script&lang=ts&"
export * from "./AllDns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports